import { type ReactNode } from 'react';

interface HeaderProps {
  breadcrumbs: string[];
  onBellClick?: () => void;
  bellCount?: number;
  rightSlot?: ReactNode;
}

export function Header({ breadcrumbs, onBellClick, bellCount = 0, rightSlot }: HeaderProps) {
  return (
    <header className="h-16 bg-white border-b border-cream-200 flex items-center px-8 gap-6 flex-shrink-0">
      <div className="flex-1 flex items-center gap-2 text-sm">
        {breadcrumbs.map((crumb, i) => (
          <span key={i} className="flex items-center gap-2">
            {i > 0 && <span className="text-navy-800/30">/</span>}
            <span className={i === breadcrumbs.length - 1 ? 'text-navy-800 font-medium' : 'text-navy-800/50'}>
              {crumb}
            </span>
          </span>
        ))}
      </div>

      {rightSlot}

      <div className="flex items-center gap-4 text-xs text-navy-800/70 font-numeric">
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse-dot" />
          <span>Live</span>
        </div>
      </div>

      {onBellClick && (
        <button
          onClick={onBellClick}
          className="relative w-9 h-9 rounded-full hover:bg-cream-100 flex items-center justify-center transition"
          title="Alerts"
          aria-label={`Alerts (${bellCount})`}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0A2540" strokeWidth="2">
            <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10.3 21a1.94 1.94 0 0 0 3.4 0" />
          </svg>
          {bellCount > 0 && (
            <span className="absolute top-1 right-1 w-4 h-4 rounded-full bg-saffron-500 text-white text-[9px] font-medium flex items-center justify-center font-numeric">
              {bellCount > 9 ? '9+' : bellCount}
            </span>
          )}
        </button>
      )}
    </header>
  );
}
